var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-between p-3 flex-wrap"},_vm._l((_vm.alternatives),function(alternative,key){return _c('v-btn',{key:key,class:{ 
      'nitro text-white border-nitro': _vm.question.user_answer.toLowerCase() === alternative.toLowerCase() , 
      'cursor-default-on-hover' : _vm.disabled
    },staticStyle:{"border":"2px solid grey","color":"gray"},attrs:{"fab":"","small":"","outlined":""},on:{"click":function($event){_vm.disabled ? null : _vm.$emit('click', alternative)}}},[_vm._v("\n    "+_vm._s(alternative)+"\n  ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }